const FUEL_TYPES = {
  GAS: {display: 'Gas', value: 'Gas', showOrder: 0, def: false},
  OTHER: {display: 'Other', value: 'Other', showOrder: 1, def: false},
};

export {FUEL_TYPES};